/**
 * Zentraler Datei-Download-Helfer (Single Source of Truth).
 *
 * Triggert einen ECHTEN Datei-Download aus einem Blob über einen Anker mit `download`-Attribut –
 * NICHT `jsPDF.save()` o. ä., das in manchen Browsern die Blob-URL nur in einem neuen Tab öffnet
 * (`window.open`-Fallback). Genutzt von `DownloadPanel` (Server-PDF/PNG/MIDI/MusicXML) und
 * `usePdfExport` (Browser-PDF), damit beide Wege exakt dasselbe, bewiesene Verhalten haben.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
